export default {
  SET_LAYOUT_PROPS: 'SET_LAYOUT_PROPS',
  SET_PROJECTS: 'SET_PROJECTS',
  SET_CONTRACTORS: 'SET_CONTRACTORS',
  SET_USER: 'SET_USER',
};
